var $c2bdd00fc73315f0$exports = {};
$c2bdd00fc73315f0$exports = {
    "loading": `Laden...`,
    "placeholder": `Selecteren\u{2026}`
};


export {$c2bdd00fc73315f0$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
